/* =============================================================================
   Al Ramaya — interactions
   Everything is re-initialisable so the Shopify theme editor picks up changes
   when a section is added, moved or reloaded.
   ========================================================================== */
(function () {
  'use strict';

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, summary, [tabindex]:not([tabindex="-1"])';
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function on(el, evt, fn, opts) { if (el) el.addEventListener(evt, fn, opts); }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* --------------------------------------------------------------------------
     Generic slide-over panel (mobile menu, collection filters)
     ----------------------------------------------------------------------- */
  function Panel(panel, opts) {
    opts = opts || {};
    this.panel = panel;
    this.openClass = opts.openClass || 'is-open';
    this.usesHidden = opts.usesHidden === true;
    this.toggle = opts.toggle || null;
    this.lastFocused = null;
    this.isOpen = false;
    this.onKeydown = this.handleKeydown.bind(this);
  }

  Panel.prototype.open = function () {
    if (this.isOpen) return;
    this.isOpen = true;
    this.lastFocused = document.activeElement;
    if (this.usesHidden) this.panel.hidden = false;
    // Force a reflow so the transition has a start value, then open synchronously.
    // requestAnimationFrame is not safe here: it is throttled in background tabs
    // and while the phone is switching apps, which would leave the panel
    // un-hidden but never slid into view, with body scroll still locked.
    void this.panel.offsetWidth;
    this.panel.classList.add(this.openClass);
    document.body.classList.add('drawer-open');
    if (this.toggle) {
      this.toggle.classList.add('is-open');
      this.toggle.setAttribute('aria-expanded', 'true');
    }
    document.addEventListener('keydown', this.onKeydown);
    var first = $(FOCUSABLE, this.panel);
    if (first) setTimeout(function () { first.focus(); }, 60);
  };

  Panel.prototype.close = function () {
    if (!this.isOpen) return;
    this.isOpen = false;
    this.panel.classList.remove(this.openClass);
    document.body.classList.remove('drawer-open');
    if (this.toggle) {
      this.toggle.classList.remove('is-open');
      this.toggle.setAttribute('aria-expanded', 'false');
    }
    document.removeEventListener('keydown', this.onKeydown);

    if (this.usesHidden) {
      var panel = this.panel;
      var hide = function () { panel.hidden = true; };
      if (prefersReducedMotion) {
        hide();
      } else {
        // hide once the slide-out finishes, whichever signal arrives first
        var done = false;
        var finish = function () { if (done) return; done = true; hide(); };
        panel.addEventListener('transitionend', finish, { once: true });
        setTimeout(finish, 500);
      }
    }
    if (this.lastFocused && this.lastFocused.focus) this.lastFocused.focus();
  };

  Panel.prototype.handleKeydown = function (e) {
    if (e.key === 'Escape') { e.preventDefault(); this.close(); return; }
    if (e.key !== 'Tab') return;
    // keep focus inside the panel while it is open
    var items = $$(FOCUSABLE, this.panel).filter(function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };

  /* --------------------------------------------------------------------------
     Mobile navigation drawer
     ----------------------------------------------------------------------- */
  function initDrawer() {
    var toggle = $('.nav-toggle');
    var drawer = $('#MobileDrawer');
    if (!toggle || !drawer || drawer.dataset.arInit) return;
    drawer.dataset.arInit = '1';

    var panel = new Panel(drawer, { usesHidden: true, toggle: toggle });

    on(toggle, 'click', function () { panel.isOpen ? panel.close() : panel.open(); });
    on($('.mobile-drawer__scrim', drawer), 'click', function () { panel.close(); });
    on($('.mobile-drawer__close', drawer), 'click', function () { panel.close(); });
    $$('a', drawer).forEach(function (a) {
      on(a, 'click', function () { panel.close(); });
    });
  }

  /* --------------------------------------------------------------------------
     Collection filters panel (mobile)
     ----------------------------------------------------------------------- */
  function initFilters() {
    var facets = $('#CollectionFilters');
    var openBtn = $('[data-filters-open]');
    if (!facets || !openBtn || facets.dataset.arInit) return;
    facets.dataset.arInit = '1';

    var panel = new Panel(facets, { toggle: openBtn });
    on(openBtn, 'click', function () { panel.open(); });
    on($('[data-filters-close]', facets), 'click', function () { panel.close(); });

    // close automatically if the viewport grows back to desktop
    var mq = window.matchMedia('(min-width: 961px)');
    var onChange = function (e) { if (e.matches && panel.isOpen) panel.close(); };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);

    // checkbox filters apply immediately on desktop; on mobile the customer
    // ticks several boxes then presses Apply
    var form = $('[data-facet-form]', facets);
    if (form) {
      $$('input[type="checkbox"]', form).forEach(function (input) {
        on(input, 'change', function () {
          if (window.matchMedia('(min-width: 961px)').matches) form.submit();
        });
      });
    }
  }

  /* --------------------------------------------------------------------------
     Sort dropdown — submit on change
     ----------------------------------------------------------------------- */
  function initSort() {
    var form = $('[data-sort-form]');
    if (!form || form.dataset.arInit) return;
    form.dataset.arInit = '1';
    var select = $('select[name="sort_by"]', form);
    on(select, 'change', function () { form.submit(); });
  }

  /* --------------------------------------------------------------------------
     Header condense on scroll
     ----------------------------------------------------------------------- */
  function initHeader() {
    var header = $('.site-header');
    if (!header || header.dataset.arInit) return;
    header.dataset.arInit = '1';

    // FIX: Bug 2 — transparent header over the homepage hero.
    // Enabled only when the page opens with a hero that has real media:
    // over the plain light gradient fallback, the white-text transparent
    // state would be unreadable. Under prefers-reduced-motion the hero's
    // video is hidden by CSS, so only a photo counts as media there.
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mediaSelector = reducedMotion
      ? '.ar-hero__media img'
      : '.ar-hero__media video, .ar-hero__media img';
    var hero = $('main > .shopify-section:first-child .ar-hero');
    document.body.classList.toggle('ar-hero-header', !!(hero && hero.querySelector(mediaSelector)));

    // FIX: Bug 2 — class flips at scrollY >= 60; update() runs once here
    // (init() is called on DOMContentLoaded) so the initial state is correct,
    // and the scroll listener is registered with { passive: true }.
    // Deliberately no requestAnimationFrame throttle: the work is a single
    // class toggle, and an rAF gate deadlocks if the frame loop is suspended
    // (backgrounded tab, iOS low-power) between a scroll event and its frame.
    var update = function () {
      // theme editor replaces the header section's DOM; drop the stale listener
      if (!header.isConnected) {
        window.removeEventListener('scroll', update);
        return;
      }
      header.classList.toggle('ar-scrolled', window.scrollY >= 60);
    };
    update();
    on(window, 'scroll', update, { passive: true });
  }

  /* --------------------------------------------------------------------------
     Announcement bar rotation
     ----------------------------------------------------------------------- */
  function initAnnouncement() {
    $$('[data-announce-rotate]').forEach(function (list) {
      if (list.dataset.arInit) return;
      list.dataset.arInit = '1';
      var items = $$('.announce__item', list);
      if (items.length < 2 || prefersReducedMotion) return;
      var delay = parseInt(list.dataset.announceRotate, 10) || 5000;
      var i = 0;
      setInterval(function () {
        if (document.hidden) return;
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, delay);
    });
  }

  /* --------------------------------------------------------------------------
     Reveal on scroll
     ----------------------------------------------------------------------- */
  function initReveal() {
    // tag the obvious candidates so sections don't each have to opt in;
    // heroes are excluded — the hero is the LCP element and must paint
    // immediately (and the transparent header needs it there from frame one)
    $$('main .shopify-section > *:first-child').forEach(function (el) {
      if (!el.classList.contains('ar-hero')) el.classList.add('reveal');
    });
    $$('main .grid--4, main .grid--3, main .grid--2').forEach(function (el) { el.classList.add('reveal', 'stagger'); });

    var targets = $$('.reveal:not(.in)');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window) || prefersReducedMotion) {
      targets.forEach(function (el) { el.classList.add('in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    targets.forEach(function (el) { io.observe(el); });

    // safety net: never leave content invisible if the observer misfires
    setTimeout(function () {
      $$('.reveal:not(.in)').forEach(function (el) { el.classList.add('in'); });
    }, 1600);
  }

  /* --------------------------------------------------------------------------
     Product: gallery, variants and the WhatsApp reserve link
     ----------------------------------------------------------------------- */
  function initProduct() {
    var root = $('[data-product-root]');
    if (!root || root.dataset.arInit) return;
    root.dataset.arInit = '1';

    var mainImage = $('[data-product-main-image]');
    var variants = [];
    var dataEl = $('[data-ar-variants]');
    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent) || []; } catch (err) { variants = []; }
    }

    /* ---- gallery ---- */
    $$('.product__thumb').forEach(function (thumb) {
      on(thumb, 'click', function () {
        if (!mainImage) return;
        mainImage.removeAttribute('srcset');
        mainImage.src = thumb.dataset.thumb;
        $$('.product__thumb').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    /* ---- reserve link ---- */
    var reserveLink = $('[data-reserve-link]');
    var mirrorLink = $('[data-reserve-link-mirror]');

    function currentSelection() {
      return $$('.product__swatch-input:checked').map(function (i) { return i.value; });
    }

    function findVariant(selection) {
      if (!variants.length) return null;
      if (!selection.length) return variants[0];
      for (var i = 0; i < variants.length; i++) {
        var opts = variants[i].options || [];
        var match = true;
        for (var j = 0; j < selection.length; j++) {
          if (opts[j] !== selection[j]) { match = false; break; }
        }
        if (match) return variants[i];
      }
      return null;
    }

    function buildReserveUrl(variant) {
      if (!reserveLink) return '';
      var number = reserveLink.dataset.waNumber || '';
      if (!number) return '';
      var lines = [
        reserveLink.dataset.waIntro || '',
        '',
        (reserveLink.dataset.productVendor || '') + ' — ' + (reserveLink.dataset.productTitle || '')
      ];
      if (variant) {
        if (variant.title && variant.title !== 'Default Title') lines.push(variant.title);
        if (variant.sku) lines.push('Ref: ' + variant.sku);
        if (variant.price) lines.push(variant.price);
      }
      lines.push('');
      lines.push(reserveLink.dataset.productUrl || window.location.href);
      return 'https://wa.me/' + number + '?text=' + encodeURIComponent(lines.join('\n'));
    }

    function updatePrice(variant) {
      if (!variant) return;
      $$('[data-price-target] .price, [data-sticky-price] .price').forEach(function (wrapper) {
        var now = $('.price__now', wrapper);
        if (!now) return; // prices are hidden by the theme setting — nothing to update
        now.textContent = variant.price;
        now.classList.toggle('price__now--sale', !!variant.compare);

        var was = $('.price__was', wrapper);
        if (variant.compare) {
          // the first variant may not have been on offer, so create the element if needed
          if (!was) {
            was = document.createElement('s');
            was.className = 'price__was';
            wrapper.insertBefore(was, now);
          }
          was.textContent = variant.compare;
          was.hidden = false;
        } else if (was) {
          was.hidden = true;
        }
      });
    }

    // grey out option values that cannot be combined with the current selection
    function updateAvailability() {
      var selection = currentSelection();
      $$('.product__swatch-input').forEach(function (input) {
        var position = parseInt(input.dataset.optionPosition, 10) - 1;
        if (isNaN(position)) return;
        var candidate = selection.slice();
        candidate[position] = input.value;

        var reachable = variants.some(function (variant) {
          var opts = variant.options || [];
          if (opts[position] !== input.value) return false;
          // only compare the options chosen before this one, so the customer is
          // never locked out of a value they have not tried yet
          for (var i = 0; i < position; i++) {
            if (opts[i] !== candidate[i]) return false;
          }
          return variant.available;
        });

        var label = document.querySelector('label[for="' + input.id + '"]');
        if (label) label.classList.toggle('is-unavailable', !reachable);
      });
    }

    function updateStock(variant) {
      var stock = $('[data-stock]');
      if (!stock || !variant) return;
      var dot = $('.product__stock-dot', stock);
      if (dot) dot.classList.toggle('product__stock-dot--out', !variant.available);
    }

    function apply() {
      var variant = findVariant(currentSelection());
      var url = buildReserveUrl(variant);

      if (reserveLink && url) reserveLink.href = url;
      if (mirrorLink && url) mirrorLink.href = url;

      if (!variant) return;

      updatePrice(variant);
      updateStock(variant);
      updateAvailability();

      // swap the hero image when the variant carries its own photo
      if (variant.image && mainImage) {
        mainImage.removeAttribute('srcset');
        mainImage.src = variant.image;
      }

      // reflect the selection in the option labels and the URL
      var selection = currentSelection();
      selection.forEach(function (value, index) {
        var display = $('[data-option-display="' + (index + 1) + '"]');
        if (display) display.textContent = value;
      });

      var sku = $('[data-product-sku]');
      if (sku && variant.sku) sku.textContent = variant.sku;

      if (window.history && window.history.replaceState) {
        var next = new URL(window.location.href);
        next.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', next.toString());
      }
    }

    $$('.product__swatch-input').forEach(function (input) { on(input, 'change', apply); });
    apply();

    /* ---- sticky reserve bar: appears once the main button scrolls away ---- */
    var sticky = $('[data-product-sticky]');
    if (sticky && reserveLink) {
      sticky.hidden = false;
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            sticky.classList.toggle('is-visible', !entry.isIntersecting);
          });
        }, { rootMargin: '-120px 0px 0px 0px' });
        io.observe(reserveLink);
      } else {
        sticky.classList.add('is-visible');
      }
    }
  }

  /* --------------------------------------------------------------------------
     Boot
     ----------------------------------------------------------------------- */
  function init() {
    initHeader();
    initDrawer();
    initFilters();
    initSort();
    initAnnouncement();
    initProduct();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: re-run when a section is re-rendered
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
  document.addEventListener('shopify:block:select', init);
})();
